export default __webpack_public_path__ + "static/media/thisWeek.93ec49bb.png";